import React from "react";
import cn from "clsx";

export interface ValidLableProps {
  classNamePrefix?: string;
  className?: string;
  text?: React.ReactNodeArray;
}

export default function ValidLableMessage({
  text: validTextDisplays,
  className,
  classNamePrefix
}: ValidLableProps) {
  if (!validTextDisplays || !validTextDisplays.length) {
    return null;
  }

  return (
    <ul className={cn(!!classNamePrefix && `${classNamePrefix}-valid-parent`)}>
      {validTextDisplays.map((text, index) => (
        <li
          key={index}
          className={cn(!!classNamePrefix && `${classNamePrefix}-valid`)}
        >
          {text}
        </li>
      ))}
    </ul>
  );
}
